import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, BoxProps } from '@mui/material';

interface DrawerPullerProps {
  onClick: (e: MouseEvent) => void;
}

const DrawerPuller = styled((props: BoxProps & DrawerPullerProps) => (
  <Box alignItems="center" justifyContent="center" {...props} />
))<BoxProps>(({ theme }) => ({
  '&:before': {
    content: "'>'",
  },
  '&:hover': {
    color: theme.palette.text.primary,
  },
  cursor: 'pointer',
  color: theme.palette.text.secondary,
  display: 'inline-flex',
  width: '20px',
  height: '40px',
  right: 0,
  top: 'calc(50% - 20px)',
  position: 'absolute',
  zIndex: 3,
  speak: 'none',
  fontWeight: 500,
  textAlign: 'center',
  background: theme.palette.background.paper,
  border: 0,
  borderRadius: '5px 0 0 5px',
}));

export { DrawerPuller };
